//imgs
import img01 from "../../assets/images/chapters/02/001.jpg";
import img02 from "../../assets/images/chapters/02/002.jpg";
import img03 from "../../assets/images/chapters/02/003.jpg";
import img04 from "../../assets/images/chapters/02/004.jpg";

import img05 from "../../assets/images/chapters/02/005.jpg";
import img06 from "../../assets/images/chapters/02/006.jpg";
import img00 from "../../assets/images/chapters/02/000.jpg";

import img07 from "../../assets/images/chapters/02/007.jpg";
import img08 from "../../assets/images/chapters/02/008.jpg";
import img09 from "../../assets/images/chapters/02/009.jpg";
import img10 from "../../assets/images/chapters/02/010.jpg";

import img11 from "../../assets/images/chapters/02/011.jpg";
import img12 from "../../assets/images/chapters/02/012.jpg";
import img13 from "../../assets/images/chapters/02/013.jpg";

import img14 from "../../assets/images/chapters/02/014.jpg";

import { captions } from "../../assets/data/chapters/chapter02";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter02">
      <div className="group01">
        <div className="row">
          <ScrollReveal className="left">
            <img src={img01} alt="" />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <ScrollReveal className="right">
            <img src={img02} alt="" />
            <p className="caption">{captions[1]}</p>
          </ScrollReveal>
        </div>
        <div className="row">
          <ScrollReveal className="left">
            <img src={img03} alt="" />
            <p className="caption">{captions[2]}</p>
          </ScrollReveal>
          <ScrollReveal className="right">
            <img src={img04} alt="" />
            <p className="caption">{captions[3]}</p>
          </ScrollReveal>
        </div>
        <ScrollReveal className="location">
          geological field{"\n"}in Sierra Blanco,{"\n"}Texas
        </ScrollReveal>
      </div>

      <div className="group02">
        <div className="row">
          <div className="left">
            <ScrollReveal className="picture">
              <img src={img05} alt="" />
              <p className="caption">{captions[4]}</p>
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img06} alt="" />
              <p className="caption">{captions[5]}</p>
            </ScrollReveal>
          </div>
          <ScrollReveal className="right">
            <img src={img00} alt="" />
            <p className="caption">{captions[6]}</p>
          </ScrollReveal>
        </div>
      </div>

      <ScrollReveal className="separator">
        <span>Flight</span>
        <span className="arrow"></span>
        <span>PŁans</span>
      </ScrollReveal>

      <div className="group03">
        <ScrollReveal className="row">
          <div className="left">
            <img src={img07} alt="" />
            <p className="caption">{captions[7]}</p>
          </div>
          <div className="right">
            <img src={img08} alt="" />
            <p className="caption">{captions[8]}</p>
          </div>
        </ScrollReveal>
        <ScrollReveal className="row">
          <div className="left">
            <img src={img09} alt="" />
            <p className="caption">{captions[9]}</p>
          </div>
          <div className="right">
            <img src={img10} alt="" />
            <p className="caption">{captions[10]}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal className="row">
          <div className="column">
            <div>
              <img src={img11} alt="" />
              <img src={img12} alt="" />
            </div>
            <p className="caption">{captions[11]}</p>
          </div>
          <div className="column">
            <img src={img13} alt="" />
            <p className="caption">{captions[12]}</p>
          </div>
          <div className="column">
            <span>
              T38{"\n"}Jet{"\n"}Trainer
            </span>
          </div>
        </ScrollReveal>
      </div>

      <ScrollReveal className="group04">
        <span>zerØ</span>
        <div className="picture">
          <img src={img14} alt="" />
          <p className="caption">{captions[13]}</p>
        </div>
        <span>
          <div>
            <p>gravity</p>
            <p>training</p>
          </div>
        </span>
      </ScrollReveal>
    </div>
  );
};

export default Chapter;
